<template lang="pug">
v-tabs(
  class="px-0 mx-0"
  v-model="tab"
  dense
  color="deep-purple accent-4"
  icons-and-text)
    v-tabs-slider

    v-tab(href="#tabLoad")
      | Cargar datos
      v-icon mdi-view-grid-plus

    v-tab(href="#tabLayers")
      | Capas cargadas ({{vectorLayers.length}})
      v-icon mdi-layers

    v-tabs-items(v-model="tab")
      v-tab-item(
        value="tabLoad")
        v-card(v-if="Object.keys(listShapefiles).length === 0 && listKml.length === 0" flat)
          v-card-text Formatos admitidos: Shapefile, GEOJSON, KML, GPX, KMZ.
            //- v-color-picker(
              class="ma-2"
              :swatches="swatches"
              show-swatches)
            v-menu(offset-y)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  small
                  :color="selectedColor"
                  dark
                  v-bind="attrs"
                  v-on="on")
                  | Seleccione color
              v-color-picker(
                v-model="selectedColor"
                hide-inputs
                hide-sliders
                hide-canvas
                class="ma-2"
                show-swatches)
          drag-zone(
            accepted-formats="application/zip,.zip,application/vnd.google-earth.kml+xml,.kml,\
            application/geojson,.geojson,vnd.google-earth.kmz+xml,.kmz,\
            application/gpx,.gpx"
            :allow-multiple="false"
            allowed-files='LOCAL')
          v-btn(
            :loading="loadingFile"
            :disabled="fileList.length === 0"
            rounded
            class="mt-2 white--text"
            block
            @click="loadLayer"
            color="green")
            | Cargar ARCHIVO
        //- Visualizacion de los archivos shape en un ZIP
        v-card(v-if="Object.keys(listShapefiles).length > 0" flat)
          v-list(dense)
            v-list-item-group(
              v-model="selectedLayer"
              active-class="")
              v-list-item(
                v-for="s in Object.keys(listShapefiles)"
                :disabled="!checkShapefile(listShapefiles[s])"
                :key="s")
                template(v-slot:default="{ active }")
                  v-list-item-action
                    v-checkbox(
                      :input-value="active")
                  v-list-item-content
                    v-list-item-title {{ s }}
                    v-list-item-subtitle
                      v-chip(
                        v-for="ext in listShapefiles[s]"
                        :key="ext"
                        class="ma-0"
                        color="success"
                        outlined)
                        v-icon(left size="18") mdi-check-circle
                        | {{ext}}
          v-btn(
            :loading="loadingLayer"
            rounded
            class="mt-2 white--text"
            block
            @click="cancelLoad"
            color="red")
            | Cancelar
          v-btn(
            :loading="loadingLayer"
            :disabled="[null, undefined].includes(selectedLayer)"
            rounded
            class="mt-2 white--text"
            block
            @click="loadSelectedLayer"
            color="green")
            | Cargar capa seleccionada
        //- Visualizacion de los capas shape en un KMZ
        v-card(v-if="listKml.length > 0" flat)
          v-list(style="max-height: 300px; overflow-y: scroll" class="scrollable" dense)
            v-list-item-group(
              v-model="selectedLayer"
              active-class="")
              v-list-item(
                v-for="l in listKml"
                :key="l.index")
                template(v-slot:default="{ active }")
                  v-list-item-action
                    v-checkbox(
                      :input-value="active")
                  v-list-item-content
                    v-list-item-title {{ l.name }}
                    v-list-item-subtitle {{ l.featureCount }} elemento(s)
          v-btn(
            :loading="loadingLayer"
            rounded
            class="mt-2 white--text"
            block
            @click="cancelLoad"
            color="red")
            | Cancelar
          v-btn(
            :loading="loadingLayer"
            :disabled="[null, undefined].includes(selectedLayer)"
            rounded
            class="mt-2 white--text"
            block
            @click="loadKmlLayer"
            color="green")
            | Cargar capa seleccionada
      v-tab-item(
        value="tabLayers")
        v-card(flat)
          v-card-text(v-if="vectorLayers.length === 0")
            | No hay capas para mostrar
          v-list(v-else subheader two-line dense)
            v-list-item(
              v-for="l in vectorLayers"
              :key="l.name")
                v-list-item-avatar(class="my-1")
                  v-icon(
                    v-if="l.geometry === 'polygon'"
                    title="Geometría Polígono"
                    class="green"
                    dark) mdi-vector-polygon
                  v-icon(
                    v-else-if="l.geometry === 'line'"
                    title="Geometría Línea"
                    class="amber"
                    dark) mdi-vector-polyline
                  v-icon(
                    v-else
                    title="Geometría Punto"
                    class="cyan"
                    dark) mdi-map-marker
                v-list-item-content
                  v-list-item-title(v-text="l.name")
                  v-list-item-subtitle {{ l.count }} elemento(s)

                v-list-item-action(class="d-flex flex-row")
                  v-btn(icon title='Centrar capa' @click="centerLayer(l.layer)")
                    v-icon(color="grey") mdi-image-filter-center-focus-strong
                  v-btn(
                    icon
                    title='Eliminar capa'
                    @click="deleteLayer(l.layer, l.name)")
                    v-icon(color="grey") mdi-trash-can
</template>

<script>
import L from 'leaflet';
import toGeoJSON from '@mapbox/togeojson';
import { mapState, mapMutations, mapActions } from 'vuex';
import JSZip from 'jszip';
import DragZone from '@/components/DragZone';

export default {
  name: 'VectorLayerPicker',

  components: {
    DragZone,
  },

  model: {
    prop: 'listLayers',
    event: 'change'
  },

  props: {
    listLayers: {
      type: Array,
      default: () => []
    }
  },

  emits: [],

  data() {
    return {
      tab: null,
      // listado de shapefiles disponibles en un ZIP
      listShapefiles: {},
      // las extensiones validas para el shapefile
      shapeExtensions: ['shp', 'shx', 'dbf', 'prj'],
      // la capa elegida para un kmz o un zip
      selectedLayer: null,
      // indica que la capa se esta procesando en el backend
      loadingLayer: false,
      // el archivo para enviar a la mutación
      file: null,
      // listado de kml disponibles en un KMZ
      listKml: [],
      // indica que el archivo se esta procesando en el backend
      loadingFile: false,
      // indica si se esta cargando un archivo KML o GPX
      fileType: null,
      // colores para las capas
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
      // estado con el color seleccionado de la capa
      selectedColor: '#F44336',
    };
  },

  computed: {
    ...mapState('files', ['fileList']),
    vectorLayers: {
      set(value) {
        this.$emit('change', value);
      },
      get() {
        return this.listLayers;
      }
    }
  },

  mounted() {},

  methods: {
    ...mapMutations('files', { filesChangeValue: 'CHANGE_VALUE' }),
    ...mapActions('geos', [
      'getGeojsonFromShapefile',
      'inspectGpxFile',
      'inspectKmzFile',
      'getGeojsonFromGpx',
      'getGeojsonFromKmz',
    ]),
    // metodo para obtener el tipo de geometría de un geojson
    classifyGeometry(geojson) {
      const [feature] = geojson.features;
      // validar el tipo de geometria
      const geometryType = feature.geometry.type;
      let type = null;
      if (['Polygon', 'MultiPolygon'].includes(geometryType)) {
        type = 'polygon';
      }
      if (['LineString', 'MultiLineString'].includes(geometryType)) {
        type = 'line';
      }
      if (['Point', 'MultiPoint'].includes(geometryType)) {
        type = 'point';
      }
      return type;
    },
    // metodo para obtner y cargar la capa en el mapa
    async loadLayer() {
      const reader = new FileReader();
      const rawFile = this.fileList[0].file;
      this.file = rawFile;
      reader.onload = async (e) => {
        let geojson = null;
        const fileName = rawFile.name.split('.')[0];
        // verificar que no haya una capa con el mismo nombre
        const layerNames = this.vectorLayers.map((x) => x.name);
        if (layerNames.includes(fileName)) {
          alert('¡Ya existe una capa con este nombre!');
          return;
        }
        // acciones para cuando el archivo es GEOJSON
        if (rawFile.name.toLowerCase().includes('.geojson')) {
          geojson = JSON.parse(e.target.result);
        }
        // acciones para cuando el archivo es KML
        if (rawFile.name.toLowerCase().includes('.kml')) {
          // Convierte el KML a GeoJSON
          const kml = new DOMParser().parseFromString(reader.result, 'text/xml');
          geojson = toGeoJSON.kml(kml);
        }
        // acciones para cuando el archivo es GPX
        if (rawFile.name.toLowerCase().includes('.gpx')) {
          this.loadingFile = true;
          this.fileType = 'GPX';
          const res = await this.inspectGpxFile({
            file: this.fileList[0].file
          });
          if (res.obtained) {
            this.listKml = res.content;
          }
          this.loadingFile = false;
          return;
        }
        // acciones para cuando el archivo es KML
        if (rawFile.name.toLowerCase().includes('.kmz')) {
          this.loadingFile = true;
          this.fileType = 'KMZ';
          const res = await this.inspectKmzFile({
            file: this.fileList[0].file
          });
          if (res.obtained) {
            this.listKml = res.content;
          }
          this.loadingFile = false;
          return;
        }
        // acciones para cuando el archivo es ZIP
        if (rawFile.name.toLowerCase().includes('.zip')) {
          const zip = await JSZip.loadAsync(rawFile);
          // const files = [];
          this.listShapefiles = {};
          zip.forEach((relativePath, zipEntry) => {
            if (!zipEntry.dir) {
              const [fName, ext] = relativePath.split('.');
              if (fName in this.listShapefiles) {
                if (this.shapeExtensions.includes(ext)) {
                  this.listShapefiles[fName].push(ext);
                }
              } else {
                // eslint-disable-next-line
                if (this.shapeExtensions.includes(ext)) {
                  this.listShapefiles[fName] = [ext];
                }
              }
            }
          });
          return;
        }
        this.processGeojson(geojson, fileName, this.selectedColor);
      };
      reader.readAsText(rawFile);
    },
    // metodo para procesar la capa en formato geojson
    processGeojson(geojson, fileName, layerColor) {
      let layer = null;
      const geometryType = this.classifyGeometry(geojson);
      if (['polygon', 'line'].includes(geometryType)) {
        layer = L.geoJSON(geojson, {
          // eslint-disable-next-line
          style: function (feature) {
            return {
              color: layerColor,
              weight: 2,
              fillOpacity: 0.5
            };
          },
          // eslint-disable-next-line
          onEachFeature: function (feature, layer) {
            // Bind a popup to each feature
            let strTemp = '';
            if (feature.properties) {
              layer.bindPopup('feature.properties');
              for (const [key, value] of Object.entries(feature.properties)) {
                strTemp += `<div><b>${key}:</b> ${value}</div>`;
              }
              layer.bindPopup(strTemp);
            }
            layer.on('click', () => { layer.openPopup(); });
            layer.on('mouseout', () => { layer.closePopup(); });
          },
        }).addTo(this.$attrs.map);
      } else {
        layer = L.geoJSON(geojson, {
          // eslint-disable-next-line
          pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, {
              radius: 15,
              fillColor: layerColor,
              color: layerColor,
              weight: 1,
              opacity: 1,
              fillOpacity: 0.7
            });
          }
        }).addTo(this.$attrs.map);
      }
      const featureCount = geojson.features.length;
      // agregar la capa al listado
      this.vectorLayers.push({
        name: fileName,
        count: featureCount,
        layer,
        geometry: geometryType,
        color: this.selectedColor,
      });
      // limpiar los archivos del drag
      this.filesChangeValue({
        value: [],
        varName: 'fileList'
      });
      this.filesChangeValue({
        value: false,
        varName: 'showFilesPreview'
      });
      // pasar a tab 2
      this.tab = 'tabLayers';
    },
    // metodo para centrar la capa en el mapa
    centerLayer(layer) {
      this.$attrs.map.fitBounds(layer.getBounds());
    },
    // metodo para eliminar la capa en el mapa
    deleteLayer(layer, layerName) {
      this.$attrs.map.removeLayer(layer);
      const i = this.vectorLayers.findIndex((x) => x.name === layerName);
      this.vectorLayers.splice(i, 1);
    },
    // metodo para verificar que todos archivos del shapefile esetn completos
    checkShapefile(extensions) {
      const isValid = this.shapeExtensions.every((ext) =>
        extensions.some((f) => f.endsWith(ext)));
      return isValid;
    },
    // metodo para cancelar la carga de shapefiles o KMZ
    cancelLoad() {
      this.fileType = null;
      this.listShapefiles = {};
      this.listKml = [];
      this.selectedLayer = null;
    },
    // metodo para procesar un archivo zip shapefile
    async loadSelectedLayer() {
      const layer = Object.keys(this.listShapefiles)[this.selectedLayer];
      // verificar que no haya una capa con el mismo nombre
      const layerNames = this.vectorLayers.map((x) => x.name);
      if (layerNames.includes(layer)) {
        alert('¡Ya existe una capa con este nombre!');
        return;
      }
      this.loadingLayer = true;
      const res = await this.getGeojsonFromShapefile({
        file: this.fileList[0].file,
        layer
      });
      if (res.obtained) {
        const geojson = res.content;
        this.processGeojson(geojson, layer, this.selectedColor);
      }
      this.cancelLoad();
      this.loadingLayer = false;
    },
    // metodo para cargar una capa de un archivo KML
    async loadKmlLayer() {
      const layer = this.listKml[this.selectedLayer].name;
      // verificar que no haya una capa con el mismo nombre
      const layerNames = this.vectorLayers.map((x) => x.name);
      if (layerNames.includes(layer)) {
        alert('¡Ya existe una capa con este nombre!');
        return;
      }
      const func = this.fileType === 'KMZ' ? 'getGeojsonFromKmz' : 'getGeojsonFromGpx';
      this.loadingLayer = true;
      const res = await this[func]({
        file: this.fileList[0].file,
        layer
      });
      if (res.obtained) {
        const geojson = res.content;
        this.processGeojson(geojson, layer, this.selectedColor);
      }
      this.cancelLoad();
      this.loadingLayer = false;
    },
  }
};
</script>

<style scoped>
</style>
